const KEYS = {
  PIPELINES: 'pipelines',
  STAGES: 'stages',
  PRIMARY: 'primary',
  DEALS: 'deals',
  BOARD: 'board',
  LIST: 'list',
  PRODUCTS: 'products',
  ORDERS: 'orders',
  INVOICES: 'invoices',
  TASKS: 'tasks',
  LEADS: 'leads',
  LOGS: 'logs',
};

const TaskFilter = {
  accountUserId: [],
  status: 'ALL',
  type: [],
};

export const DEMO_ACCOUNT_USER = {
  photoUrl: '',
  itemLabel: 'Jane Doe',
  description: 'sample@admin.com',
  value: 'test-admin',
};

export const DEMO_CONTACT = {
  photoUrl: '',
  itemLabel: 'John Doe',
  description: 'sample@user.com',
  value: 'test-user',
};

export default {
  ...KEYS,
  TaskFilter,
};
